import React, { useEffect, useState } from "react";
import PopupModal from "../../../Components/ModalComponent/PopupModal";

import { ManageApis } from "../../../AppServices/ManageApi";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import Loader from "../../../Components/LoaderComponent/Loader";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";
import nodata from "../../../assets/images/no-data.png";
import { MultiSelect } from "react-multi-select-component";
import {
  PreventNonNumeric,
  dataTableInitialLoader,
  emailValidation,
  formateString,
  formatingValue,
  handleCopy,
  limitCharacters,
  preventSpecialChars,
  userValidation,
} from "../../../Functions/Utils";
import DataTable from "../../../Components/DataTable/DataTable";
import { Input, Message, Select } from "@arco-design/web-react";
const InputSearch = Input.Search;

function UserListing() {
  let userCreateinitialValue = {
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    mappingUserClientRequest: [],
    password: "",
  };
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [visible, setVisible] = useState({
    show: false,
    type: "",
  });
  const customStyles = {
    option: 'custom-option', // custom class for options
  };
  const [searchText, setSearchText] = useState("");
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [UserList, setUserList] = useState([]);
  const [userAccountListData, setUserAccountListData] = useState([]);
  const [getAllAccount, setGetAllAccount] = useState([]);
  const [data, setData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [pageSize, setpageSize] = useState(10);
  const [createUserData, setCreateUserData] = useState(userCreateinitialValue);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [option, setOption] = useState([]);
  const [newAccount, setNewAccount] = useState([]);
  const [currentUserId, setCurrentUserId] = useState()
  const navigate = useNavigate();
  useEffect(() => {
    getUserList();
    listAcountId();
    localStorage.removeItem("storedLockenabled");
  }, []);
  useEffect(() => {
    // //console.log("---------->", createUserData)
  }, [createUserData]);

  let newUserCreateForm = [
    {
      type: "text",
      name: "firstName",
      label: "First Name",
      regex: formatingValue,
    },
    {
      type: "text",
      name: "lastName",
      label: "Last Name",
      regex: formatingValue,
    },
    { type: "text", name: "email", label: "Email", regex: emailValidation() },
    {
      type: "text",
      name: "username",
      label: "User Name",
      regex: limitCharacters,
    },
    // { type: "select", name: "accountsId", label: "Account Type", regex: "" },
    { type: "password", name: "password", label: "Password", regex: "" },
  ];

  const options = [
    { label: "Grapes 🍇", value: "grapes" },
    { label: "Mango 🥭", value: "mango" },
    { label: "Strawberry 🍓", value: "strawberry" },
  ];

  const accountsColumn = [
    {
      title: "Account Name",
      dataIndex: "clientName",
    },
    {
      title: "Status",
      dataIndex: "status",
    }, {
      title: "Account Id",
      dataIndex: "",
      width: "200px",
      render: (text, record) => (
        // //console.log(record),

     
        <button
          className="btn btn-master w-75 px-2 font_13 py-1 text-nowrap"
          onClick={() => handleCopy(record?.clientId)}
        >
          Copy Account Id
        </button>
      ),
    },
    {
      title: "Action",
      width: "230px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          <>
            <div className="row">
              <div className="col-12 col-md-6 p-0 pe-md-2">
                <button
                  className="btn btn-master w-100 px-2 font_13 py-1 mb-1 text-nowrap"
                  onClick={() => handleActivateDeactivateAccount(record)}
                >
                  {record?.status == "Active" ? "Deactivate" : "Activate"}
                </button>
              </div >
              <div className="col-12 col-md-6 p-0">
                <button
                  className="btn btn-master px-2 w-100 font_13 py-1 text-nowrap"
                  onClick={() => handleRemoveRecord(record)}
                >
                  Remove
                </button>
              </div>
            </div >
          </>
        );
      },
    },
  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "fullName",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Accounts",
      dataIndex: "createdDate",
      render: (text, record) => (
        // //console.log(record),

        <i
          className="far fa-eye  icn p-2 text_master"
          onClick={() => handleListAccount(record.id)}
        ></i>
      ),
    },
    {
    title: "User Id",
      dataIndex: "",
      width: "200px",
      render: (text, record) => (
      <>
      
      
      <button
      className="sm-d-none btn btn-master px-2 w-100 font_13 py-1 md-d-block text-nowrap"
      onClick={() =>  handleCopy(record?.id)}
    >
      Copy User Id
          </button>
         
      </>
       
    ),
   
},
    {
      title: "Action",
      width: "200px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          <>
       
           <button
           className="btn btn-master px-2 w-100 font_13 py-1 text-nowrap"
           onClick={() => onclickView(record)}
         >
           View
            </button>
            </>
        );
      },
    },
  ];

  const getUserList = async () => {
    try {
      setIsLoading(true);
      let response = await ManageApis("get", global.getUserListData);
    
      console.log(response,'datas');
      if (response.message === "Success") {
        // ""
        setIsLoading(false);
        setData((prev) =>
          response?.response_data?.map(
            ({ id, firstName, lastName, email, lockoutEnabled }) => ({
              id,
              fullName: `${firstName} ${lastName}`,
              email,
              lockoutEnabled,
            })
          )
        );
        setUserList((prev) =>
          response?.response_data?.map(
            ({ id, firstName, lastName, email, lockoutEnabled }) => ({
              id,
              fullName: `${firstName} ${lastName}`,
              email,
              lockoutEnabled,
            })
          )
        );
      } else {
        // //console.log(response);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };
  const onclickView = (param) => {
    // ""
    //handle on click view btn in table

    navigate("/admin/user-details", { state: { userData: param } });
  };

  const handleChange = (e, regex) => {
    const { name, value } = e.target;
    switch (name) {
      case "email":
        setCreateUserData((prv) => ({ ...prv, [name]: value }));
        handleError(null, name);
        break;
      case "password":
        setCreateUserData((prv) => ({ ...prv, [name]: value }));
        handleError(null, name);
        break;
      case "userName":
        setCreateUserData((prv) => ({ ...prv, [name]: value }));
        handleError(null, name);
        break;
      // case "accountsId":
      //   setCreateUserData((prv) => ({ ...prv, [name]: value }));
      //   handleError(null, name);
      //   break;
      case name:
        setCreateUserData((prv) => ({
          ...prv,
          [name]: regex(value, 100, /[^a-zA-Z \s]/g),
        }));
        handleError(null, name);

        break;

      default:
        break;
    }
  };

  const handleError = (error, input) => {
    // ""
    setErrors((prevState) => ({ ...prevState, [input]: error }));
  };
  const validate = () => {
    // ""
    let isValid = true;

    let array = Object.keys(createUserData);
    let result = userValidation(createUserData, array);
    // ""
    if (!emailValidation(createUserData.email)) {
      handleError(`Please enter the Email`, "email");
      isValid = false;
    }
    result.forEach((item) => {
      // ""
      if (item == "mappingUserClientRequest") {
        handleError(`Please Select an Account Type`, item);
        isValid = false;

      }
      else {
        handleError(`Please fill the ${item.replace("_", " ")}`, item);
        isValid = false;
      }
    });

    // //console.log(result);
    // ""

    Object.keys(errors).forEach((key) => {
      if (errors[key]) {
        isValid = false;
        // //console.log(errors[key]);
      }
    });

    return isValid;
  };


  // useEffect(() => {
  //   // ""
  //   //console.log("Validation Errors ===>", errors)
  // }, [errors])
  const handleCreateUserSubmit = async () => {
    // ""
    const accountList = selected.map((itm) => ({ clientid: itm.value }))
    setCreateUserData((prv) => ({ ...prv, ["mappingUserClientRequest"]: accountList }));
    try {
      // const validate = () => {
      //   let isValid = true;

      //   let array = Object.keys(createUserData);
      //   let result = userValidation(createUserData, array);

      //   result.forEach((item) => {
      //     handleError(`Please fill the ${item.replace("_", " ")}`, item);
      //     isValid = false;
      //   });

      // //console.log(result);
      // ""
      //   if (!emailValidation(createUserData.email)) {
      //     handleError(`Please enter a valid Email`, "email");
      //   }

      //   Object.keys(errors).forEach((key) => {
      //     if (errors[key]) {
      //       isValid = false;
      // //console.log(errors[key]);
      //     }
      //   });

      //   return isValid;
      // };


      if (validate()) {
        // ""
        setVisible(() => ({
          show: false,
          type: "",
        }));
        setIsLoading(true);
        const reqstBody = createUserData;
        //console.log(reqstBody);
        // return
        let response = await ManageApis(
          "post",
          global.CreateClientUser,
          reqstBody
        );

        if (response.message === "Success") {
          // //console.log(response);

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "User Created Successfully",
            isSuccess: true,
          }));

          // setUserList((prev) => [

          //   {
          //     id: response?.response_data?.userId,
          //     fullName: `${createUserData.firstName} ${createUserData.lastName}`,
          //     email: createUserData.email,
          //   },
          //   ...prev,
          // ]);

          setCreateUserData(userCreateinitialValue);
          setSelected([])

          setIsLoading(false);
        } else {
          setVisible(() => ({
            show: false,
            type: "",
          }));
          setIsLoading(false);
          setCreateUserData(userCreateinitialValue);
          setSelected([])
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message:
              response?.response_data?.message || "Something went wrong...!",
            isfalse: true,
          }));
        }
      } else {
        setVisible(() => ({
          show: true,
          type: "createuser",
        }));
      }
    } catch (er) {
      setVisible(() => ({
        show: false,
        type: "",
      }));
      setIsLoading(false);
      setCreateUserData(userCreateinitialValue);
      setSelected([])

      setShowAlert((pre) => ({
        ...pre,
        show: true,
        message: "Something went wrong...!",
        isfalse: true,
      }));
      // //console.log(er);
    }
  };
  const handleAlertBoxCancel = () => {
    if (showAlert.isSuccess) {
      getUserList();
      setShowAlert(AlertinitialValue);
    } else {
      setShowAlert(AlertinitialValue);
    }
  };

  const handleMultiselect = (e, type) => {
    // ""
    if (type == "newClient") {
      //console.log(e);
      setSelected(e);
      setErrors({})

      const accountList = e.map((itm) => ({ clientid: itm.value }));

      setCreateUserData((prv) => ({
        ...prv,
        ["mappingUserClientRequest"]: accountList,
      }));
    }
    else {
      const accountList = e.map((itm) => ({ clientid: itm.value }));

      setSelectedAccount(e);
      setNewAccount((prv) => ({
        ...prv,
        ["accountList"]: accountList,
      }));

    }
  };

  function onChangeTable(pagination) {
    // //console.log(pagination);
    const { current, pageSize } = pagination;
    setTableLoader(true);
    setUserList(dataTableInitialLoader(columns));

    setTimeout(() => {
      setUserList(data.slice((current - 1) * pageSize, current * pageSize));
      setcurrentPage(current);
      setpageSize(pageSize);
      setTableLoader(false);
    }, 2000);
  }

  const listAcountId = async () => {
    try {
      let result = await ManageApis("get", global.getClientsList);
      if (result.message == "Success") {
        setOption(
          result.response_data.map((itm) => ({
            label: itm.name,
            value: itm.id,
            key: itm.id,
          }))
        );
        setGetAllAccount(result.response_data);
      } else {
        // //console.log(result);
      }
    } catch (error) {
      // //console.log(error);
    }
  };

  const handlesearch = (value) => {
    setSearchText(formatingValue(value, 20, /[^a-zA-Z\s]/g));
    try {
      if (searchText) {
        setUserList(() =>
          data.filter((itm) =>
            itm?.fullName?.toLowerCase().includes(value?.toLowerCase())
          )
        );
      } else {
        setUserList(data);
      }
    } catch (error) {
      // console.error("An error occurred:", error.message);
    }
  };
  const handleListAccount = async (id) => {
    setNewAccount()
    setSelectedAccount([])
    setCurrentUserId(id)
    try {
      // ""
      setIsLoading(true);
      let param = `?UserId=${id}`;
      let result = await ManageApis("get", global.GetAccountName, param);
      if (result.message === "Success") {


        let formatedData = result?.response_data?.map((itm) => ({
          ...itm,
          userId: id,
        }));
        setUserAccountListData(formatedData);
        setIsLoading(false);

        setVisible(() => ({ type: "list_account", show: true }));
      } else {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Something went wrong...!",
          isfalse: true,
        }));
      }
    } catch (error) {
      setIsLoading(false);
      // //console.log(error)
    }
  };

  // handle removeclient by user
  const handleRemoveRecord = async (data) => {
    try {

      //console.log("dd", data);
      let param = `?userId=${data?.userId}&clientId=${data?.clientId}`;
      setIsLoading(true)
      setVisible((pre) => ({ show: false, type: "" }));
      let result = await ManageApis(
        "post",
        global.RemoveClientByUser + param
      );
      if (result?.message == "Success") {

        Message.success("Delete Account Successfully");
        setIsLoading(false);
      } else {
        setIsLoading(false);

        Message.error(
          result?.message || "Something went wrong! Please try again later."
        );
      }


    } catch (error) {
      setIsLoading(false)
      //console.log(error)
    }


  };

  const handleActivateDeactivateAccount = async (data) => {
    try {
      //console.log(data);
      let param = `?userId=${data?.userId}&clientId=${data?.clientId}`;
      //  ? 'Deactivate' : 'Activate'
      if (data?.status == "Active") {
        setIsLoading(true);
        setVisible((pre) => ({ show: false, type: "" }));
        // try to deactivate on active case
        let result = await ManageApis(
          "post",
          global.DeactivateClientByUser + param
        );
        if (result?.message == "Success") {
          Message.success("Deactivated Successfully ");
          setIsLoading(false);
        } else {
          setIsLoading(false);

          Message.error(
            result?.message || "Something went wrong! Please try again later."
          );
        }
      } else {
        setIsLoading(true);
        setVisible((pre) => ({ show: false, type: "" }));
        let result = await ManageApis(
          "post",
          global.ActivateClientByUser + param
        );
        if (result?.message == "Success") {
          Message.success("Activated Successfully");
          setIsLoading(false);
        } else {
          setIsLoading(false);

          Message.error(
            result?.message || "Something went wrong! Please try again later."
          );
        }
      }
      //console.log(param);
    } catch (error) {
      //console.log(error);
    }
  };

  const handleAddAccounts = async () => {
    // ""
    setIsLoading(true)
    setVisible((pre) => ({ show: false, type: "" }));
    const rqstbdy = {
      userId: currentUserId,
      accounts: newAccount?.accountList
    }
    //console.log(rqstbdy)
    const result = await ManageApis("post", global.addNewAccounts, rqstbdy)
    if (result?.message == "Success") {
      Message.success(result?.response_data || "Account Added Successfully");
      setIsLoading(false);
      setNewAccount()
      setSelectedAccount([])
    } else {
      setIsLoading(false);
      setNewAccount()
      setSelectedAccount([])

      Message.error(
       result?.response_data  || result?.message || "Something went wrong! Please try again later."
      );
    }
  }

  const renderPopup = () => {
    switch (visible.type) {
      case "list_account":
        return (
          <>
            {/* <div className="row align-items-center">
              <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
                <div className=" pt-2">
                  {userAccountListData.length ? <ul className="list-unstyled">

                    {userAccountListData.map((itm) => (
                      // //console.log("------------------------->", itm),
                      <li className="border-bottom" >
                        {Object.values(itm)}
                      </li>
                    ))}
                  </ul> : <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
                    <img
                      src={nodata}
                      className="no_data_thumbnail object_fit_contain"
                    />
                    <h4 className="text_gray7 font_16 mt-3">
                      {" "}
                      No Data To Preview
                    </h4>
                  </div>}
                </div>
              </div>
            </div> */}
            <DataTable
              columnData={accountsColumn}
              rowData={userAccountListData}

            // total={userAccountListData?.length}
            // onChangeTable={onChangeTable}
            />
          </>
        );
        break;
      case "createuser":
        return (
          <div className="row align-items-center">
            <div className="col-12 text_m1 fw_500 d-none">Menu</div>
            <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
              <div className=" pt-2">
                <div className="data w-100">
                  {newUserCreateForm.map((itm) =>
                    itm.type == "select" ? (
                      <div>
                        <div className="form_bx_stack mb-1 ">
                          <label className="mb-0 text_m1 text-black font_15">
                            {itm?.label}
                          </label>
                          <span className="text-danger">*</span>
                          <div className="data w-100 mt-1 input_withicon end">
                            <select
                              className="form-control pe-0"
                              name={itm?.name}
                              value={createUserData?.mappingUserClientRequest}
                              onChange={(e) => handleChange(e)}
                            >
                              <option value={""}>Select Account type...</option>
                              {getAllAccount.map((itm) => (
                                <option value={itm?.id}>{itm?.name}</option>
                              ))}
                            </select>

                            <i class="fas fa-angle-down icn p-2 text_gray "></i>
                          </div>
                        </div>
                        {errors[itm?.name] && (
                          <span className="font_12 ps-1 text-danger text-capitalize">
                            {errors[itm?.name]}
                          </span>
                        )}
                      </div>
                    ) : (
                      <InputComponent2
                        label={itm?.label}
                        name={itm?.name}
                        type={itm?.type}
                        onchange={(e) => handleChange(e, itm?.regex)}
                        value={createUserData[itm?.name] || ""}
                        error={errors[itm?.name]}
                        maxLength={50}
                      />
                    )
                  )}
                  <label className="mb-0 text_m1 text-black font_15">
                    Account Type
                  </label>
                  <span className="text-danger">*</span>

                  <div className="multi-custom-style">

                    <MultiSelect
                      options={option}
                      value={selected}
                      onChange={(e) => handleMultiselect(e, "newClient")}

                      className="text-black"
                      labelledBy="Select"

                    />
                    {true && (
                      <span className="font_12 ps-1 text-danger">
                        {errors.mappingUserClientRequest}
                      </span>
                    )}
                  </div>

                </div>
              </div>
              <div className="mt-4 d-flex justify-content-end">
                <button
                  className="btn btn-master px-3 font_14"
                  onClick={handleCreateUserSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        );
        break;
      case "Add_Account":
        return (
          <>
            <div className="multi-custom-style">

              <MultiSelect
                options={option}
                value={selectedAccount}
                onChange={handleMultiselect}

                className="text-black"
                labelledBy="Select"

              />
              {true && (
                <span className="font_12 ps-1 text-danger">
                  {errors.mappingUserClientRequest}
                </span>
              )}
            </div>
            <div className="mt-4 d-flex justify-content-end gap-1">
              <button
                className="btn btn-master px-3 font_14 "
                onClick={() => setVisible(() => ({ type: "list_account", show: true }))}
              >
                Back
              </button>
              <button
                className="btn btn-master px-3 font_14 "
                onClick={handleAddAccounts}
              >
                Submit
              </button>
            </div >
          </>
        );
        break
      default:
        break;
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={handleAlertBoxCancel}
      />
      <div className="p-2">
        <section className="admin_Section ">
          <div
            className={`d-flex justify-content-between align-items-center ${data?.length > 0 ? "" : "d-none"
              }`}
          >
            <h3 className="text_master2 mb-0 text-uppercase  py-2 font_18 fw_600">
              User List
            </h3>
            <div className="  flex-column flex-md-row g-1 d-flex gap-1 justify-content-between ">
              <div className=" arco_inputsearch ">
                <InputSearch
                  value={searchText}
                  onChange={handlesearch}
                  allowClear
                  placeholder="Enter username "
                />
              </div>
              <button
                className="btn btn-master font_14 px-4"
                onClick={() =>
                  setVisible(() => ({
                    show: true,
                    type: "createuser",
                  }))
                }
              >
                Add New User +
              </button>
            </div>
          </div>
          <div className="table_type02 pb-5 mt-3 table-responsive custom_scroll1 h-100">
            {!data?.length > 0 ? (
              <div className="d-flex  h-100">
                <div className="m-auto text-center">
                  <i className="fas fa-user-alt-slash font_18 mb-2"></i>
                  <div className="pb-2">Currently No User Available</div>
                  <button
                    className="btn btn-master font_14 px-4"
                    onClick={() =>
                      setVisible(() => ({
                        show: true,
                        type: "createuser",
                      }))
                    }
                  >
                    Add New User +
                  </button>
                </div>
              </div>
            ) : (
              // <TableComponent
              //   onclickView={onclickView}
              //   tableHeader={["Name", "Email", ""]}
              //   ListingData={UserList}
              //   tableData={["fullName", "email"]}
              // />
              <DataTable
                columnData={columns}
                rowData={UserList}
                onChangeTable={onChangeTable}
                current={currentPage}
                pageSize={pageSize}
                total={data?.length}
                loading={tableLoader}
              />
            )}
          </div>
        </section>
      </div>

      <PopupModal
        title={`${visible.type == "list_account" ? "Accounts List" : visible.type == "Enter Details" ? "Enter Details": visible.type == "Add_Account" ? "Add Account" : "Add New User"
          }`}
        size="lg"
        visible={visible.show}
        backdrop={"static"}
        onClick={() => setVisible(() => ({ type: "Add_Account", show: true }))}
        handleClose={() => {
          setVisible((pre) => ({ type: "", show: false }));
          setCreateUserData(userCreateinitialValue);
          setSelected([])
          setErrors({})

        }}
      >
        {renderPopup()}
      </PopupModal>
    </>
  );
}

export default UserListing;
